module.exports = __webpack_public_path__ + "img/MED_LEGUMES@300x.cfcc3c27.png";